module.exports = __webpack_public_path__ + "assets/webgl/art_109_L0.aa21d438.jpg";